import { useMemo } from "react";
import { KeyedMutator } from "swr";

import { useBankAccountById } from "../../../api/bankAccount";
import { ApiError } from "../../../api/common";
import { BankAccount } from "../../../types/common";

type useAccountProps = {
    bankAccount: BankAccount | undefined;
    error: ApiError | undefined;
    mutate: KeyedMutator<BankAccount>;
    isValidating: boolean;
};


const useAccount = (id: string): useAccountProps => {
    const { data, error, mutate, isValidating } = useBankAccountById(id);
    const bankAccount: BankAccount | undefined = useMemo(
        () => data,
        [data],
    );

    return {
        bankAccount,
        error,
        mutate,
        isValidating,
    };
};

export default useAccount;
